import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { SeguridadService } from '../modules/sistema/services/seguridad/seguridad.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private _router = inject(Router);
  private _seguridadService = inject(SeguridadService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let accessToken = this._seguridadService.obtenerAccessToken();
    if (!accessToken) {
      this._router.navigate(['/main']);
      return false;
    }

    if (!this._seguridadService.esSesionActiva()) {
      if (this._seguridadService.esUsuarioImpersonado()) {
        this._seguridadService.regresarAlUsuarioOriginal();
        return false;
      }
      return this._seguridadService.refrescarTokenSiNecesario().pipe(
        map(nuevoToken => {
          if (!nuevoToken) {
            this._router.navigate(['/main']);
            return false;
          }
          return true;
        }),
        catchError(() => {
          this._router.navigate(['/main']);
          return of(false);
        })
      );
    }
    return true;
  }
}
